<template>
    <div class="options">
        <label
            v-for="option in options"
            :key="option.value"
            class="option-label"
            :class="{ selected: modelValue === option.value }"
        >
            <input
                type="radio"
                :value="option.value"
                :checked="modelValue === option.value"
                @input="$emit('update:modelValue', option.value)"
                :disabled="disabled"
            />
            <span class="option-text">
                <strong>{{ option.value }})</strong>
                {{ option.text }}
            </span>
        </label>
    </div>
</template>

<script setup>
import { onMounted, onUpdated, nextTick } from 'vue';
import renderMathInElement from 'katex/contrib/auto-render';
import 'katex/dist/katex.min.css';

defineProps({
    modelValue: String,
    options: {
        type: Array,
        default: () => []
    },
    disabled: Boolean
});

defineEmits(['update:modelValue']);

const renderMath = async () => {
    await nextTick();
    await new Promise(r => setTimeout(r, 0));
    
    const questionSection = document.querySelector('.options');
    if (questionSection) {
        renderMathInElement(questionSection, {
            delimiters: [
                { left: '$$', right: '$$', display: true },
                { left: '\\[', right: '\\]', display: true },
                { left: '\\(', right: '\\)', display: false },
                { left: '$', right: '$', display: false },
            ],
            throwOnError: false,
            errorCallback: (msg, err) => {
                console.error('KaTeX error:', msg, err);
            },
        });
    }
};

onMounted(renderMath);
onUpdated(renderMath);
</script>

<style scoped>
.options {
    margin-bottom: 30px;
}

.option-label {
    display: block;
    padding: 15px;
    margin-bottom: 12px;
    border: 2px solid rgba(var(--accent-rgb), 0.4);
    cursor: pointer;
    transition: all 0.2s;
    background: rgba(var(--bg-secondary-rgb), 0.4);
}

.option-label:hover {
    border-color: var(--accent);
    background: var(--bg-secondary);
}

.option-label.selected {
    border-color: var(--accent);
    background: var(--bg-secondary);
}

.option-label input[type="radio"] {
    margin-right: 12px;
}

.option-text {
    font-size: 15px;
    color: var(--text-primary);
}

input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}

</style>